/**
 * Helpers shared by every CMS agent's tool set.
 *
 * withQueue serialises human-in-the-loop steps so two approvals can never be
 * outstanding at once; toMd converts stored HTML for display.
 */

import * as turndownLib from "turndown"

export function toMd(html: string): string {
  try { return new turndownLib.default().turndown(html) } catch { return html }
}

/** Serializes any async operation through a queue. Queue always advances even on error. */
export async function withQueue<T>(
  queueRef: { current: Promise<void> },
  fn: () => Promise<T>,
): Promise<T> {
  let result: T = undefined as T
  let err: unknown = undefined

  await new Promise<void>(resolveQueue => {
    queueRef.current = queueRef.current.then(async () => {
      try { result = await fn() }
      catch (e) { err = e }
      finally { resolveQueue() }
    })
  })

  if (err !== undefined) throw err
  return result
}
